import clsx from "clsx";
import shape from "../../assets/img/shapes/parasuit-shape-01.webp";


const ParasuitShape01 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-parasuit-shape-01", props.className)}>
            <img src={shape} alt="rmdr-parasuit-shape-01" loading="lazy" width={68} height={94} />
        </div>
    )

}

export default ParasuitShape01;
